import { useState } from "react";
import { Link, useLocation } from "react-router-dom";

import { useApp } from "../../Context";

import { AdvertiseModal } from "../Modals";

//import assets
import { LogoHorizontal } from "../../Assets/logo";
import Close from "../../Assets/Close";
import Menu from "../../Assets/Menu";

export const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { pathname } = useLocation();

  const { showAdModal, handleShowAdModal, handleShowChatBubble } = useApp();

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <nav className="w-full fixed top-0 left-0 z-50 bg-background/95 backdrop-blur-md shadow-sm border-b border-primary/10">
      {/* Container für horizontales Layout */}
      <div className="max-w-7xl mx-auto px-4 lg:px-8">
        <div className="flex items-center justify-between py-3">
          {/* Logo (horizontal) Links */}
          <Link 
            to="/" 
            className="transform transition-all duration-300 hover:scale-105 flex-shrink-0"
          >
            <LogoHorizontal height={36} />
          </Link>

          {/* Navigation Items - Desktop (Mitte/daneben) */}
          <ul className="hidden md:flex items-center gap-x-10 flex-1 ml-12">
            <li className="relative group">
              <Link
                className="text-gray font-helvetica text-[15px] font-medium tracking-wide 
                         uppercase transition-all duration-300 
                         hover:text-primary hover:tracking-wider
                         flex items-center gap-2"
                to="/"
              >
                <span className="relative">
                  Suchen
                  {pathname === "/" && (
                    <span className="absolute -bottom-2 left-0 w-full h-0.5 bg-primary 
                                   rounded-full animate-slideIn" />
                  )}
                  {pathname !== "/" && (
                    <span className="absolute -bottom-2 left-0 w-0 h-0.5 bg-primary 
                                   rounded-full transition-all duration-300 group-hover:w-full" />
                  )}
                </span>
              </Link>
            </li>
            
            <li className="relative group">
              <Link
                className="text-gray font-helvetica text-[15px] font-medium tracking-wide 
                         uppercase transition-all duration-300 
                         hover:text-primary hover:tracking-wider
                         flex items-center gap-2"
                to="/about_us"
              >
                <span className="relative">
                  Über Uns
                  {pathname === "/about_us" && (
                    <span className="absolute -bottom-2 left-0 w-full h-0.5 bg-primary 
                                   rounded-full animate-slideIn" />
                  )}
                  {pathname !== "/about_us" && (
                    <span className="absolute -bottom-2 left-0 w-0 h-0.5 bg-primary 
                                   rounded-full transition-all duration-300 group-hover:w-full" />
                  )}
                </span>
              </Link>
            </li>

            <li className="relative group">
              <Link
                className="text-gray font-helvetica text-[15px] font-medium tracking-wide 
                         uppercase transition-all duration-300 
                         hover:text-primary hover:tracking-wider
                         flex items-center gap-2"
                to="/rechner"
              >
                <span className="relative">
                  Rechner
                  {pathname === "/rechner" && (
                    <span className="absolute -bottom-2 left-0 w-full h-0.5 bg-primary 
                                   rounded-full animate-slideIn" />
                  )}
                  {pathname !== "/rechner" && (
                    <span className="absolute -bottom-2 left-0 w-0 h-0.5 bg-primary 
                                   rounded-full transition-all duration-300 group-hover:w-full" />
                  )}
                </span>
              </Link>
            </li>

            <li className="relative group">
              <Link
                className="text-gray font-helvetica text-[15px] font-medium tracking-wide 
                         uppercase transition-all duration-300 
                         hover:text-primary hover:tracking-wider
                         flex items-center gap-2"
                to="/bewertung"
              >
                <span className="relative">
                  Bewertung
                  {pathname === "/bewertung" && (
                    <span className="absolute -bottom-2 left-0 w-full h-0.5 bg-primary 
                                   rounded-full animate-slideIn" />
                  )}
                  {pathname !== "/bewertung" && (
                    <span className="absolute -bottom-2 left-0 w-0 h-0.5 bg-primary 
                                   rounded-full transition-all duration-300 group-hover:w-full" />
                  )}
                </span>
              </Link>
            </li>
            
            <li className="relative group">
              <button
                className="text-gray font-helvetica text-[15px] font-medium tracking-wide 
                         uppercase transition-all duration-300 
                         hover:text-primary hover:tracking-wider
                         flex items-center gap-2"
                onClick={handleShowChatBubble}
              >
                <span className="relative">
                  Kontakt
                  <span className="absolute -bottom-2 left-0 w-0 h-0.5 bg-primary 
                               rounded-full transition-all duration-300 group-hover:w-full" />
                </span>
              </button>
            </li>
          </ul>

          {/* Inserieren Button - Rechts */}
          <div className="hidden md:block flex-shrink-0">
            <button
              className="text-primary font-helvetica text-[15px] font-medium tracking-wide 
                       uppercase transition-all duration-300 
                       border-2 border-primary hover:bg-primary hover:text-background
                       px-6 py-2 rounded-full
                       transform hover:-translate-y-0.5
                       active:translate-y-0"
              onClick={handleShowAdModal}
            >
              Inserieren
            </button>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex-shrink-0">
            <button 
              onClick={toggleMenu}
              className="p-2 rounded-lg hover:bg-primary/5 transition-colors duration-200"
            >
              {isOpen ? <Close /> : <Menu />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        <div
          className={`md:hidden transition-all duration-500 ease-in-out ${
            isOpen
              ? "max-h-96 opacity-100 pb-4"
              : "max-h-0 opacity-0 overflow-hidden"
          }`}
        >
          <ul className="flex flex-col gap-y-4 pt-2">
            <li className="relative group">
              <Link
                className="text-gray font-helvetica text-[15px] font-medium tracking-wide 
                         uppercase transition-all duration-300 
                         hover:text-primary
                         flex items-center gap-2 py-2"
                to="/"
                onClick={() => setIsOpen(false)}
              >
                <span className="relative">
                  Suchen
                  {pathname === "/" && (
                    <span className="absolute -bottom-1 left-0 w-full h-0.5 bg-primary rounded-full" />
                  )}
                </span>
              </Link>
            </li>
            
            <li className="relative group">
              <Link
                className="text-gray font-helvetica text-[15px] font-medium tracking-wide 
                         uppercase transition-all duration-300 
                         hover:text-primary
                         flex items-center gap-2 py-2"
                to="/about_us"
                onClick={() => setIsOpen(false)}
              >
                <span className="relative">
                  Über Uns
                  {pathname === "/about_us" && (
                    <span className="absolute -bottom-1 left-0 w-full h-0.5 bg-primary rounded-full" />
                  )}
                </span>
              </Link>
            </li>

            <li className="relative group">
              <Link
                className="text-gray font-helvetica text-[15px] font-medium tracking-wide 
                         uppercase transition-all duration-300 
                         hover:text-primary
                         flex items-center gap-2 py-2"
                to="/rechner"
                onClick={() => setIsOpen(false)}
              >
                <span className="relative">
                  Rechner
                  {pathname === "/rechner" && (
                    <span className="absolute -bottom-1 left-0 w-full h-0.5 bg-primary rounded-full" />
                  )}
                </span>
              </Link>
            </li>

            <li className="relative group">
              <Link
                className="text-gray font-helvetica text-[15px] font-medium tracking-wide 
                         uppercase transition-all duration-300 
                         hover:text-primary
                         flex items-center gap-2 py-2"
                to="/bewertung"
                onClick={() => setIsOpen(false)}
              >
                <span className="relative">
                  Bewertung
                  {pathname === "/bewertung" && (
                    <span className="absolute -bottom-1 left-0 w-full h-0.5 bg-primary rounded-full" />
                  )}
                </span>
              </Link>
            </li>
            
            <li className="relative group">
              <button
                className="text-gray font-helvetica text-[15px] font-medium tracking-wide 
                         uppercase transition-all duration-300 
                         hover:text-primary
                         flex items-center gap-2 py-2"
                onClick={() => {
                  handleShowChatBubble();
                  setIsOpen(false);
                }}
              >
                Kontakt
              </button>
            </li>
            
            <li className="pt-2">
              <button
                className="text-primary font-helvetica text-[15px] font-medium tracking-wide 
                         uppercase transition-all duration-300 
                         border-2 border-primary hover:bg-primary hover:text-background
                         px-6 py-2 rounded-full w-full"
                onClick={() => {
                  handleShowAdModal();
                  setIsOpen(false);
                }}
              >
                Inserieren
              </button>
            </li>
          </ul>
        </div>
      </div>
      
      <AdvertiseModal open={showAdModal} handler={handleShowAdModal} />
    </nav>
  );
};
